(() => {
  const initialize = (section) => {
    if (section.dataset.iamaranthShopReady === 'true') return;
    section.dataset.iamaranthShopReady = 'true';
    const filters = section.querySelectorAll('[data-shop-filter]');
    const products = section.querySelectorAll('[data-shop-family]');
    const clear = section.querySelector('[data-shop-clear]');
    const count = section.querySelector('[data-shop-count]');
    const empty = section.querySelector('[data-shop-empty]');
    const selectFamily = (family) => {
      let visible = 0;
      products.forEach((product) => {
        const matches = family === 'all' || product.dataset.shopFamily === family;
        product.hidden = !matches;
        if (matches) visible += 1;
      });
      filters.forEach((filter) => {
        const active = filter.dataset.shopFilter === family;
        filter.classList.toggle('is-active', active);
        filter.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (clear) clear.hidden = family === 'all';
      if (count) count.textContent = visible;
      if (empty) empty.hidden = visible !== 0;
    };
    filters.forEach((filter) => filter.addEventListener('click', () => selectFamily(filter.dataset.shopFilter)));
    if (clear) clear.addEventListener('click', () => selectFamily('all'));
  };
  const initializeAll = () => document.querySelectorAll('[data-iamaranth-shop]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
})();
